import { render } from "./ItemEditSettings.vue?vue&type=template&id=6f8cafb1&scoped=true&bindings={\"modelValue\":\"props\",\"item\":\"data\",\"languages\":\"data\",\"setRouteColor\":\"options\"}"
import script from "./ItemEditSettings.vue?vue&type=script&lang=js"
export * from "./ItemEditSettings.vue?vue&type=script&lang=js"

import "./ItemEditSettings.vue?vue&type=style&index=0&id=6f8cafb1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f8cafb1"

export default script